import React from 'react';
import { HomeContextProvider } from 'Context/HomeContext';
import HomeContainer from './Container';

const Home = (props) => {
  return (
    <HomeContextProvider>
      <HomeContainer {...props} />
    </HomeContextProvider>
  );
};

export default Home;
